

import { SearchParamsType } from "../../Masters/TemplateMaster/types";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import { MasterDataListType, MasterDataType, TagListType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const {SettingsApi} = api
export const getMasterTableData = async (searchParams:SearchParamsType):Promise<ResponseType<{expenceDto:MasterDataListType[],totalCount:number}>>=>{
    const result = await instance.post(`${SettingsApi.getAllExpense}`,searchParams);
    return result.data;
}

export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<string | null>>=>{
    const result = await instance.post(`${SettingsApi.SaveExpense}`,params);
    return result.data;
}

export const getAllTag= async ():Promise<ResponseType<TagListType[]>>=>{
    const result = await instance.get(`${SettingsApi.getAllTag}${clinicId}`);
    return result.data;
}